import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";

const obrazci = [
  "UPRAVLJANJE OTPADOM",
  "SREDSTVA ZA ZAŠTITU ŽIVOTNE SREDINE",
  "ZŠS DOKUMENTACIJA",
  "OBUKA ZAPOSLENIH",
  "UPUTSTVA I OZNAKE",
  "ZAGAĐUJUĆE MATERIJE"
];

function ShowBarZastitaZivSredine() {
  const { selectedZastitaZivSredine, setSelectedZastitaZivSredine } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedZastitaZivSredine !== index + 1) {
      setSelectedZastitaZivSredine(index + 1);
    } else {
      setSelectedZastitaZivSredine(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {obrazci.map((obrazac, i) => (
        <div onClick={() => handleClickObrazac(i)}>
          <Button
            active={selectedZastitaZivSredine === i + 1}
            style={{
              padding: "7px",
              fontWeight: "bold",
              textAlign: "left",
              minHeight: "64px",
              display: "block",
              fontSize: "16px"
            }}
          >
            {obrazac}
          </Button>
        </div>
      ))}
    </div>
  );
}

export default ShowBarZastitaZivSredine;
